// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imageViewerViewport {\n  width: 100%;\n  height: 100%;\n/* background-size: cover; */\n  background-size: 100% 100%;\n  outline: 0 !important;\n  line-height: 0px;\n  overflow: hidden;\n}\n.viewport-color-box {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  width: 25px;\n  height: 25px;\n  border-radius: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
